module.exports = __webpack_public_path__ + "img/me.0ea1cdea.jpg";